var _circle, _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTotalSupportSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#3182ce",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.163 10C13.163 12.6921 12.7347 15.0952 12.0685 16.7978C11.7345 17.6514 11.3553 18.2911 10.9726 18.7048C10.5906 19.1177 10.2613 19.25 9.99996 19.25C9.73866 19.25 9.40929 19.1177 9.02736 18.7048C8.64463 18.2911 8.26546 17.6514 7.93145 16.7978C7.26524 15.0952 6.83691 12.6921 6.83691 10C6.83691 7.30787 7.26524 4.90476 7.93145 3.20223C8.26546 2.34865 8.64463 1.70887 9.02736 1.29517C9.40929 0.882341 9.73866 0.75 9.99996 0.75C10.2613 0.75 10.5906 0.882341 10.9726 1.29517C11.3553 1.70887 11.7345 2.34865 12.0685 3.20223C12.7347 4.90476 13.163 7.30787 13.163 10Z",
    stroke: "#3182ce",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 7.25,
    x2: 19,
    y2: 7.25,
    stroke: "#3182ce",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 13.25,
    x2: 19,
    y2: 13.25,
    stroke: "#3182ce",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalSupportSite);
export default __webpack_public_path__ + "static/media/icon_total_support_site.8365dfd1fdb058d15204bc6ed721c35b.svg";
export { ForwardRef as ReactComponent };